"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'tilesFocusTV';
exports.SET_FOCUSED_ROW = exports.namespace + "/SET_FOCUSED_ROW";
exports.SET_IS_FOCUSED = exports.namespace + "/SET_IS_FOCUSED";
exports.SET_FOCUSED_ELEMENT = exports.namespace + "/SET_FOCUSED_ELEMENT";
exports.SET_FOCUSED_STATE = exports.namespace + "/SET_FOCUSED_STATE";
//# sourceMappingURL=constants.js.map